module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-rqf-page",
    attrs: {
      "id": "damages"
    }
  }, [(_vm.$root.car.model) ? [_c('h3', [_vm._v("Skader")]), _vm._v(" "), _c('div', {
    staticClass: "car-make-and-model"
  }, [_c('img', {
    attrs: {
      "src": _vm.$root.car.brand_logo
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "car-make-and-model-details"
  }, [_c('div', {
    staticClass: "car-make-and-model-year",
    domProps: {
      "textContent": _vm._s(_vm.$root.car.year)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "car-make-and-model-model",
    domProps: {
      "textContent": _vm._s(_vm.$root.car.producer + ' ' + _vm.$root.car.model)
    }
  })])])] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "damages-wrap"
  }, [_c('h3', [_vm._v("Start med å legge til en skade")]), _vm._v(" "), _c('p', [_vm._v("Marker med et klikk på modellen hvor skaden er og last opp bilder av skaden. Vi ønsker veldig gjerne å gi deg\n      ett så nøyaktig prisestimat som mulig, så fint om du gjør følgende:")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', [_vm._v("Se eksempel på "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.$root.showUILightbox()
      }
    }
  }, [_vm._v("hvilke type bilder du kan ta")]), _vm._v(".\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "damages-form"
  }, [_c('div', {
    staticClass: "damage"
  }, [_vm._l((_vm.$root.damages), function(damage, damageIndex) {
    return [_c('div', {
      staticClass: "damage-item",
      class: {
        active: ((null === damage.active && 0 === damageIndex) || true === damage.active)
      }
    }, [_c('div', {
      staticClass: "damage-label",
      on: {
        "click": function($event) {
          return _vm.$root.toggleDamageContentView(damageIndex)
        }
      }
    }, [(0 === damageIndex) ? _c('span', {
      staticClass: "text"
    }, [_vm._v("Front")]) : (1 === damageIndex) ? _c('span', {
      staticClass: "text"
    }, [_vm._v("Høyre side")]) : (2 === damageIndex) ? _c('span', {
      staticClass: "text"
    }, [_vm._v("Bakpart")]) : (3 === damageIndex) ? _c('span', {
      staticClass: "text"
    }, [_vm._v("Venstre side")]) : (4 === damageIndex) ? _c('span', {
      staticClass: "text"
    }, [_vm._v("Kilometerteller")]) : (5 === damageIndex) ? _c('span', {
      staticClass: "text"
    }, [_vm._v("Drivstoff")]) : (6 === damageIndex) ? _c('span', {
      staticClass: "text"
    }, [_vm._v("Tak")]) : (7 === damageIndex) ? _c('span', {
      staticClass: "text"
    }, [_vm._v("Documents")]) : _c('span', {
      staticClass: "text"
    }, [_vm._v("Ekstra bilde")]), _vm._v(" "), _c('span', {
      staticClass: "icon"
    })]), _vm._v(" "), _c('div', {
      staticClass: "damages-block"
    }, [_c('div', {
      staticClass: "preview-wrap"
    }, [_c('ul', {
      staticClass: "preview"
    }, _vm._l((damage.images), function(fileId, index) {
      return _c('li', [_c('img', {
        attrs: {
          "src": _vm.$root.files[fileId].url,
          "alt": 'Skade ' + (index + 1)
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "remove",
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.$root.removeImage(index, damageIndex)
          }
        }
      }, [_c('svg', {
        attrs: {
          "height": "24",
          "viewBox": "0 0 24 24",
          "width": "24",
          "xmlns": "http://www.w3.org/2000/svg"
        }
      }, [_c('path', {
        attrs: {
          "d": "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
        }
      })])])])
    }), 0), _vm._v(" "), _c('label', {
      staticClass: "upload",
      attrs: {
        "for": 'mps-upload-image-' + damageIndex
      }
    }, [_c('svg', {
      attrs: {
        "height": "24",
        "viewBox": "0 0 24 24",
        "width": "24",
        "xmlns": "http://www.w3.org/2000/svg"
      }
    }, [_c('circle', {
      attrs: {
        "cx": "12",
        "cy": "12",
        "r": "3.2"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
      }
    })]), _vm._v(" "), _c('image-uploader', {
      attrs: {
        "id": 'mps-upload-image-' + damageIndex,
        "debug": 2,
        "maxWidth": 2000,
        "maxHeight": 2000,
        "quality": 0.7,
        "autoRotate": true,
        "outputFormat": "verbose",
        "preview": false,
        "capture": false,
        "doNotResize": "['gif', 'svg']",
        "accept": "image/*"
      },
      on: {
        "input": function($event) {
          return _vm.$root.addImage($event, damageIndex)
        },
        "onUpload": _vm.$root.onStartUploadImage,
        "onComplete": _vm.$root.onCompleteUploadImage
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "cursor"
    })], 1), _vm._v(" "), (!damage.images.length && _vm.$root.damages.length > 7 && damageIndex > 6) ? _c('span', {
      staticClass: "remove",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.$root.removeDamage(damageIndex)
        }
      }
    }, [_c('svg', {
      attrs: {
        "height": "24",
        "viewBox": "0 0 24 24",
        "width": "24",
        "xmlns": "http://www.w3.org/2000/svg"
      }
    }, [_c('path', {
      attrs: {
        "d": "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
      }
    })])]) : _vm._e()]), _vm._v(" "), (7 !== damageIndex) ? _c('div', {
      staticClass: "form-damage-description"
    }, [_c('label', {
      attrs: {
        "for": 'description_' + +(damageIndex + 1)
      }
    }, [_vm._v("Beskrivelse Skade")]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.$root.request['description_' + +(damageIndex + 1)]),
        expression: "$root.request['description_' + + (damageIndex+1)]"
      }],
      attrs: {
        "id": 'description_' + +(damageIndex + 1),
        "rows": "2"
      },
      domProps: {
        "value": (_vm.$root.request['description_' + +(damageIndex + 1)])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.$root.request, 'description_' + +(damageIndex + 1), $event.target.value)
        }
      }
    })]) : _vm._e()])])]
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "mps-actions first-screen-actions"
  }, [_c('button', {
    staticClass: "button primary",
    attrs: {
      "id": "js-add-damage"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$root.addDamage.apply(null, arguments)
      }
    }
  }, [_vm._v("Legg til skade")]), _vm._v(" "), _c('button', {
    staticClass: "button secondary",
    attrs: {
      "id": "gtm-inquiry-continue-damages"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$root.submitDamages.apply(null, arguments)
      }
    }
  }, [_vm._v("\n        Fortsett\n      ")])])])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("Send oss 4 – 6 bilder!\n        "), _c('br'), _vm._v("2 detalj- og 2 oversiktsbilder fra forskjellige vinkler\n      ")]), _vm._v(" "), _c('li', [_vm._v("Fint om bilen er ren")]), _vm._v(" "), _c('li', [_vm._v("Pass på at bildene er i fokus")]), _vm._v(" "), _c('li', [_vm._v("Ta gjerne bilder i godt lys som naturlig dagslys")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c4bbb64"}!./~/vue-loader/lib/selector.js?type=template&index=0!./requests/assets/src/components/Opq/Damages.vue
// module id = 111
// module chunks = 0